import React, { useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, IconButton, Grid, Typography,
  Box, Button, TextField, Paper, Slide, FormControl, InputLabel,
  Select, MenuItem
} from "@mui/material";
import { Close as CloseIcon, UploadFile as UploadIcon } from "@mui/icons-material";
import { putData } from "../../BaseUrl";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const YES_NO_OPTIONS = [
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" }
];

const OPTION_OPTIONS = [
  { value: "option1", label: "Option 1" },
  { value: "option2", label: "Option 2" },
  { value: "option3", label: "Option 3" }
];

const BiliteracyDetailDialog = ({ open, onClose, record, onSuccess }) => {
  const [approveCredential, setApproveCredential] = useState("");
  const [rejectReason, setRejectReason] = useState("");
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    skippedGrade: record?.skippedGrade || "",
    registeredForNilai08: record?.registeredForNilai08 || "",
    sealOfBiliteracy: record?.sealOfBiliteracy || "",
    option: record?.option || ""
  });

  if (!record) return null;

  const handleFormChange = (field) => (e) => {
    setForm(prev => ({ ...prev, [field]: e.target.value }));
  };

  const handleApprove = async () => {
    setLoading(true);
    try {
      await putData(`admin/biliteracy-mgmt/update/${record.id}`, {
        status: "payment_completed",
        ...form
      });
      onSuccess("Biliteracy application approved successfully");
    } catch (err) {
      setLoading(false);
    }
  };

  const handleReject = async () => {
    setLoading(true);
    try {
      await putData(`admin/biliteracy-mgmt/update/${record.id}`, {
        status: "rejected"
      });
      onSuccess("Biliteracy application rejected");
    } catch (err) {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth TransitionComponent={Transition}>
      <DialogTitle sx={{ p: 0 }}>
        {/* Gradient Header Banner */}
        <Box sx={{
          background: "linear-gradient(135deg, #336599 0%, #A9C2DB 100%)",
          p: 3, position: "relative", color: "#fff"
        }}>
          <IconButton onClick={onClose} size="small"
            sx={{ position: "absolute", top: 12, right: 12, color: "#fff" }}>
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" fontWeight="bold">
            {record.studentName || record.name || "Student"}
          </Typography>
          <Box sx={{
            display: "inline-block", mt: 1, px: 1.5, py: 0.5,
            backgroundColor: "rgba(255,255,255,0.2)", borderRadius: 1
          }}>
            <Typography variant="caption" sx={{ color: "#fff" }}>
              App No: {record.applicationNumber || record.appNo || "-"}
            </Typography>
          </Box>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ p: 0 }}>
        <Grid container>
          {/* Left: Form Details */}
          <Grid item xs={12} md={7} sx={{ p: 3, borderRight: { md: "1px solid #e0e0e0" } }}>
            <Typography variant="subtitle1" fontWeight="bold" color="#1a237e" mb={2}>
              Biliteracy Details
            </Typography>

            <TextField label="Student Name" value={record.studentName || record.name || ""} size="small"
              fullWidth InputProps={{ readOnly: true }} sx={{ mb: 2 }} />
            <TextField label="Application No" value={record.applicationNumber || record.appNo || ""}
              size="small" fullWidth InputProps={{ readOnly: true }} sx={{ mb: 2 }} />

            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField label="Grade" value={record.grade || ""} size="small" fullWidth
                  InputProps={{ readOnly: true }} sx={{ mb: 2 }} />
              </Grid>
              <Grid item xs={6}>
                <TextField label="Section" value={record.section || ""} size="small" fullWidth
                  InputProps={{ readOnly: true }} sx={{ mb: 2 }} />
              </Grid>
            </Grid>

            <Grid container spacing={2}>
              <Grid item xs={6}>
                <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                  <InputLabel>Skipped Grade</InputLabel>
                  <Select value={form.skippedGrade} label="Skipped Grade"
                    onChange={handleFormChange("skippedGrade")}>
                    {YES_NO_OPTIONS.map(o => (
                      <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                  <InputLabel>Registered For Nilai08</InputLabel>
                  <Select value={form.registeredForNilai08} label="Registered For Nilai08"
                    onChange={handleFormChange("registeredForNilai08")}>
                    {YES_NO_OPTIONS.map(o => (
                      <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>

            <Grid container spacing={2}>
              <Grid item xs={6}>
                <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                  <InputLabel>Seal Of Biliteracy</InputLabel>
                  <Select value={form.sealOfBiliteracy} label="Seal Of Biliteracy"
                    onChange={handleFormChange("sealOfBiliteracy")}>
                    {YES_NO_OPTIONS.map(o => (
                      <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                  <InputLabel>Option</InputLabel>
                  <Select value={form.option} label="Option"
                    onChange={handleFormChange("option")}>
                    {OPTION_OPTIONS.map(o => (
                      <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>

            <TextField label="Enrolled Date" value={record.enrolled || record.enrolledDate || ""}
              size="small" fullWidth InputProps={{ readOnly: true }} sx={{ mb: 2 }} />
            <TextField label="Evaluated Date" value={record.evaluatedDate || ""} size="small"
              fullWidth InputProps={{ readOnly: true }} sx={{ mb: 2 }} />

            <Button variant="outlined" startIcon={<UploadIcon />}
              component="label"
              sx={{ textTransform: "none", mt: 1 }}>
              Upload Document
              <input type="file" hidden />
            </Button>
          </Grid>

          {/* Right: Action Panels */}
          <Grid item xs={12} md={5} sx={{ p: 3, backgroundColor: "#fafafa" }}>
            {/* Approve Panel */}
            <Paper sx={{ p: 2, mb: 3, borderRadius: 2, border: "1px solid #e0e0e0" }}>
              <Typography variant="subtitle2" fontWeight="bold" color="#2e7d32" mb={2}>
                Approve Application
              </Typography>
              <TextField
                label="User Credential"
                placeholder="Enter your credential to approve"
                value={approveCredential}
                onChange={(e) => setApproveCredential(e.target.value)}
                multiline rows={3} size="small" fullWidth sx={{ mb: 2 }}
              />
              <Button
                variant="contained"
                fullWidth
                disabled={loading || !approveCredential}
                onClick={handleApprove}
                sx={{
                  backgroundColor: "#4caf50",
                  "&:hover": { backgroundColor: "#388e3c" },
                  textTransform: "none", fontWeight: 600
                }}
              >
                Approve & Assign
              </Button>
            </Paper>

            {/* Reject Panel */}
            <Paper sx={{ p: 2, borderRadius: 2, border: "1px solid #e0e0e0" }}>
              <Typography variant="subtitle2" fontWeight="bold" color="#c62828" mb={2}>
                Reject Application
              </Typography>
              <TextField
                label="Reason for Rejection"
                placeholder="Enter reason for rejection"
                value={rejectReason}
                onChange={(e) => setRejectReason(e.target.value)}
                multiline rows={3} size="small" fullWidth sx={{ mb: 2 }}
              />
              <Button
                variant="contained"
                fullWidth
                disabled={loading || !rejectReason}
                onClick={handleReject}
                sx={{
                  backgroundColor: "#f44336",
                  "&:hover": { backgroundColor: "#c62828" },
                  textTransform: "none", fontWeight: 600
                }}
              >
                Reject
              </Button>
            </Paper>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default BiliteracyDetailDialog;
